import Head from 'next/head';

/**
 * Auth pages may carry CLI claim keys in the URL. Avoid leaking them via Referer.
 */
const AuthSensitivePageHead = () => (
  <Head>
    <meta name="referrer" content="no-referrer" />
  </Head>
);

export default AuthSensitivePageHead;
